import { useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

/**
 * 用户资料完整性检查组件
 * 在用户登录后检查用户资料是否完整，特别是来自Apple登录的用户
 */
export function ProfileCheck() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // 检查是否需要验证用户资料完整性
    const provider = sessionStorage.getItem('checkProfileCompleteness');
    if (!provider) return;

    // 清除标记，避免重复检查
    sessionStorage.removeItem('checkProfileCompleteness');

    // 确保用户已加载
    if (!user) return;

    // 检查用户资料是否完整
    const isProfileComplete = !!user.name && !!user.avatar;
    
    // 如果是Apple登录用户且资料不完整，提示用户
    if (provider === 'apple' && !isProfileComplete) {
      console.log('Apple user profile incomplete:', user);
      
      // 显示提示消息
      toast.info('Complete Your Profile', {
        description: 'Please complete your profile information for a better experience.',
        action: {
          label: 'Update Profile',
          onClick: () => navigate('/profile/settings')
        },
        duration: 8000,
      });
    } else if (!isProfileComplete) {
      // 其他提供商的用户资料不完整情况
      console.log('User profile incomplete:', user);
      
      // 可以选择显示不同的提示或者直接导航到资料设置页面
      // navigate('/profile/settings');
    }
  }, [user, navigate]);

  // 不渲染任何内容，只运行检查逻辑
  return null;
}

export default ProfileCheck; 
